import { supabase } from '../lib/supabase';

export interface GameSubstitution {
  id: string;
  game_id: string;
  player_out_id: string | null;
  player_in_id: string | null;
  quarter: number | null;
  reason: string | null;
  created_at: string;
}

export type CreateGameSubstitution = Pick<
  GameSubstitution,
  'game_id' | 'player_out_id' | 'player_in_id' | 'quarter' | 'reason'
>;

class GameSubstitutionService {
  async list(gameId: string): Promise<GameSubstitution[]> {
    const { data, error } = await supabase
      .from('game_substitutions')
      .select('*')
      .eq('game_id', gameId)
      .order('created_at', { ascending: true });
    if (error) {
      console.error('[GameSubstitutionService] list error:', error);
      throw error;
    }
    return (data as GameSubstitution[]) || [];
  }

  async add(entry: CreateGameSubstitution): Promise<GameSubstitution> {
    const { data, error } = await supabase
      .from('game_substitutions')
      .insert(entry)
      .select()
      .single();
    if (error) {
      console.error('[GameSubstitutionService] add error:', error);
      throw error;
    }
    return data as GameSubstitution;
  }

  async remove(id: string): Promise<void> {
    const { error } = await supabase
      .from('game_substitutions')
      .delete()
      .eq('id', id);
    if (error) {
      console.error('[GameSubstitutionService] remove error:', error);
      throw error;
    }
  }
}

export const gameSubstitutionService = new GameSubstitutionService();

export function quarterLabel(quarter: number | null): string {
  if (quarter === null) return '';
  if (quarter === 5) return 'OT';
  return `Q${quarter}`;
}
